/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-vendor-payment-tracker.reducer';

export const PharmacyVendorPaymentTracker = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyVendorPaymentTrackerList = useAppSelector(state => state.pharmacyVendorPaymentTracker.entities);
  const loading = useAppSelector(state => state.pharmacyVendorPaymentTracker.loading);
  const totalItems = useAppSelector(state => state.pharmacyVendorPaymentTracker.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-vendor-payment-tracker-heading" data-cy="PharmacyVendorPaymentTrackerHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.home.title">Pharmacy Vendor Payment Trackers</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-vendor-payment-tracker/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.home.createLabel">
              Create new Pharmacy Vendor Payment Tracker
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyVendorPaymentTrackerList && pharmacyVendorPaymentTrackerList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('settledAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.settledAmount">Settled Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('settledAmount')} />
                </th>
                <th className="hand" onClick={sort('transactionType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.transactionType">Transaction Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactionType')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.returnPayment">Return Payment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.purchasePayment">Purchase Payment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.parentCredit">Parent Credit</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.pharmacy">Pharmacy</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.payedCredit">Payed Credit</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.supplier">Supplier</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyVendorPaymentTrackerList.map((pharmacyVendorPaymentTracker, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-vendor-payment-tracker/${pharmacyVendorPaymentTracker.id}`} color="link" size="sm">
                      {pharmacyVendorPaymentTracker.id}
                    </Button>
                  </td>
                  <td>{pharmacyVendorPaymentTracker.settledAmount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TransactionType.${pharmacyVendorPaymentTracker.transactionType}`} />
                  </td>
                  <td>{pharmacyVendorPaymentTracker.addedById}</td>
                  <td>{pharmacyVendorPaymentTracker.modifiedById}</td>
                  <td>{pharmacyVendorPaymentTracker.active ? 'true' : 'false'}</td>
                  <td>{pharmacyVendorPaymentTracker.cursor}</td>
                  <td>{pharmacyVendorPaymentTracker.timestampEntry}</td>
                  <td>{pharmacyVendorPaymentTracker.microSec}</td>
                  <td>{pharmacyVendorPaymentTracker.lastUpdated}</td>
                  <td>
                    {pharmacyVendorPaymentTracker.returnPayment ? (
                      <Link to={`/pharmacy-return-bill-payment/${pharmacyVendorPaymentTracker.returnPayment.id}`}>
                        {pharmacyVendorPaymentTracker.returnPayment.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyVendorPaymentTracker.purchasePayment ? (
                      <Link to={`/pharmacy-payment-history/${pharmacyVendorPaymentTracker.purchasePayment.id}`}>
                        {pharmacyVendorPaymentTracker.purchasePayment.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyVendorPaymentTracker.parentCredit ? (
                      <Link to={`/pharmacy-credit/${pharmacyVendorPaymentTracker.parentCredit.id}`}>
                        {pharmacyVendorPaymentTracker.parentCredit.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyVendorPaymentTracker.pharmacy ? (
                      <Link to={`/pharmacy/${pharmacyVendorPaymentTracker.pharmacy.id}`}>{pharmacyVendorPaymentTracker.pharmacy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyVendorPaymentTracker.payedCredit ? (
                      <Link to={`/pharmacy-credit/${pharmacyVendorPaymentTracker.payedCredit.id}`}>
                        {pharmacyVendorPaymentTracker.payedCredit.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyVendorPaymentTracker.supplier ? (
                      <Link to={`/pharmacy-suppliers/${pharmacyVendorPaymentTracker.supplier.id}`}>
                        {pharmacyVendorPaymentTracker.supplier.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-vendor-payment-tracker/${pharmacyVendorPaymentTracker.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-vendor-payment-tracker/${pharmacyVendorPaymentTracker.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-vendor-payment-tracker/${pharmacyVendorPaymentTracker.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.home.notFound">
                No Pharmacy Vendor Payment Trackers found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyVendorPaymentTrackerList && pharmacyVendorPaymentTrackerList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyVendorPaymentTracker;
